import * as React from 'react';
import Link from 'components/link/link';
import { P1 } from 'components/typography';
import { baseUrl } from 'lib/base-url';
import { basePath } from 'lib/base-path';
import { StructuredData } from 'components/structured-data';
import { Maybe, RootQueryToCategoryConnection } from 'interfaces/microsite-cms';
import lexemes from 'components/lexemes/index/lexemes';

export function setBreadCrumbs({
    categories,
    name,
    slug,
}: {
    categories?: Maybe<RootQueryToCategoryConnection>;
    name?: string;
    slug?: string;
}) {
    const breadcrumbsElementList = [
        { name: lexemes.lxBreadcrumbsFirstItemTitle, slug: basePath },
        categories?.edges ? categories?.edges[0]?.node : null,
        { name, slug },
    ]
        .filter((breadcrumb) => breadcrumb?.name)
        .map((item, index) => {
            if (!item?.slug?.startsWith(basePath)) {
                //@ts-ignore
                item.slug = `${basePath}${item?.slug}`;
            }
            //@ts-ignore
            item.order = index;
            return item;
        })
        .filter((breadcrumb) => breadcrumb?.name);

    return breadcrumbsElementList as BreadcrumbsItem[];
}

export type BreadcrumbsItem = {
    name: string;
    slug: string;
    order: number;
};

export type BreadcrumbsProps = {
    list: BreadcrumbsItem[];
};

export default function breadcrumbs({ list }: BreadcrumbsProps) {
    return (
        <>
            <StructuredData
                id="page-breadcrumbs"
                type={StructuredData.type.BreadcrumbList}
                data={{
                    url: `${baseUrl}${list[list.length - 1].slug}`,
                    items: list.map((listItem) => {
                        return {
                            name: listItem.name,
                            item: `${baseUrl}${listItem.slug}`,
                            order: listItem.order,
                        };
                    }),
                }}
            />
            <ol className="breadcrumbs" id="breadcrumbs">
                {list
                    .filter((breadcrumbItem) => breadcrumbItem)
                    .sort((prev, next) => prev.order - next.order)
                    .map((breadcrumb) => (
                        <li className="breadcrumbs__item" key={breadcrumb?.slug}>
                            {breadcrumb.order !== 0 ? (
                                <div className="breadcrumbs__icon">{'>'}</div>
                            ) : null}
                            <Link
                                className="breadcrumbs__url"
                                href={breadcrumb.slug}
                                title={breadcrumb.name}
                            >
                                <P1 inline={true} color="grey">
                                    {breadcrumb.name}
                                </P1>
                            </Link>
                        </li>
                    ))}
            </ol>
        </>
    );
}
